import { ReactNode, createContext, useContext } from 'react';

const FeatureFlagsContext = createContext({
  s3bKioskSoftwareRenameToKioskLite: false,
  savedCardsEnabled: false,
  addressValidationEnabled: false,
});

/*
  Custom hook to extract feature flag details

  Usage:
    const featureFlag = useFeatureFlags();
    mpoPhase3Enabled = featureFlag.mpoPhase3Enabled;
    recommendedProductsEnabled = featureFlag.recommendedProductsEnabled;
 */
const useFeatureFlags = () => {
  return useContext(FeatureFlagsContext);
};

interface FeatureFlagsProps {
  children: ReactNode;
  featureFlags: Record<string, any>;
}

/*
  Provides a component that wraps your app with
  details about feature flags
 */
const FeatureFlags = ({ children, featureFlags }: FeatureFlagsProps) => {
  const values = {
    s3bKioskSoftwareRenameToKioskLite:
      featureFlags.s3b_kiosk_software_rename_to_kiosk_lite || false,
    savedCardsEnabled: featureFlags.saved_cards_enabled || false,
    addressValidationEnabled: featureFlags.address_validation_enabled || false,
  };

  return (
    <FeatureFlagsContext.Provider value={values}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export { FeatureFlags, useFeatureFlags };
